export default function PhilosophySection() {
  return (
    <section id="apropos" className="py-12 md:py-24 bg-[#f5fdf8]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-16">
          {/* Left: Image */}
          <div className="w-full lg:w-1/2 relative">
            <div className="relative rounded-2xl overflow-hidden" style={{ height: "260px" }}>
              <img
                src="https://static.readdy.ai/image/8892c16dc9d95083db2eef95f931ffc6/99e8414c0420d7163c402b3d750666df.png"
                alt="Notre approche KS BTP Étanchéité"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-6">
                <span className="text-xs text-gray-300 uppercase tracking-widest">Notre engagement</span>
                <p className="text-white font-bold text-base md:text-xl mt-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  Qualité, coordination et respect des délais
                </p>
              </div>
            </div>
            {/* Floating badge desktop only */}
            <div className="absolute -top-5 -right-5 bg-[#00a340] text-white rounded-xl px-5 py-4 hidden lg:block">
              <div className="text-2xl font-black">26+</div>
              <div className="text-xs text-green-200">Ans d&apos;expertise</div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="w-full lg:w-1/2">
            {/* Logo */}
            <div className="mb-4 flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#00a340]">
                <span className="text-white font-black text-base">KS</span>
              </div>
              <div>
                <span className="text-2xl font-extrabold text-gray-900" style={{ fontFamily: "'Montserrat', sans-serif" }}>BTP</span>
                <div className="text-xs text-gray-400 uppercase tracking-widest">Spécialiste en Étanchéité</div>
              </div>
            </div>

            <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-4 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              <span className="italic text-[#00a340]">Notre</span> engagement<br />pour vos projets
            </h2>

            <div className="w-12 h-1 bg-[#00a340] rounded-full mb-5"></div>

            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4 text-justify">
              KS BTP serait particulièrement heureuse et honorée de pouvoir participer dans le cadre de ses compétences à la réalisation de vos projets d&apos;étanchéité. Les <strong className="text-gray-800">matériaux d&apos;étanchéité</strong> que nous utilisons sont parfaitement adaptés à la nature des divers projets et répondent bien aux contraintes climatiques de la région.
            </p>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4 text-justify">
              KS BTP dispose d&apos;un <strong className="text-gray-800">savoir-faire et d&apos;une expertise reconnue</strong> dans le domaine de l&apos;étanchéité, avec toutes les compétences requises pour réaliser seule vos travaux, avec une bonne coordination et un respect des délais.
            </p>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-5 text-justify">
              KS BTP met tout en œuvre pour garantir la qualité de chaque chantier, de l&apos;étude technique à la livraison finale. Notre équipe d&apos;encadrement et nos compagnons qualifiés assurent un suivi rigoureux à chaque étape du projet.
            </p>

            <div className="flex flex-col gap-3">
              <a
                href="#realisations"
                onClick={(e) => { e.preventDefault(); document.querySelector("#realisations")?.scrollIntoView({ behavior: "smooth" }); }}
                className="inline-flex items-center gap-2 text-[#00a340] font-bold text-sm border-b-2 border-[#4cd97a] pb-1 w-fit cursor-pointer hover:text-[#007a30] transition-colors"
              >
                Voir nos réalisations
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#partenariat"
                onClick={(e) => { e.preventDefault(); document.querySelector("#partenariat")?.scrollIntoView({ behavior: "smooth" }); }}
                className="inline-flex items-center gap-2 text-[#00a340] font-bold text-sm border-b-2 border-[#4cd97a] pb-1 w-fit cursor-pointer hover:text-[#007a30] transition-colors"
              >
                Nos certifications &amp; qualifications
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
